import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
  width: 772px;
  min-height: 48px;
  border-radius: 8px;

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
    width: 382px;
    min-height: 72px;
    border-radius: 16px;
    padding: 0;
  }
`;

export const Label = styled.label`
  padding: 0 12px;
  width: 250px;
  color: var(--Neutral-Dark-Blue, #00223c);
  font-weight: 700;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: 1.5px;
  vertical-align: middle;

  @media (max-width: 820px) {
    width: auto;
    padding: 0;
  }
`;

export const StyledText = styled.span`
  padding: 0 12px;
  flex: 1;
  color: ${customPalette.grey[800]};
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  resize: none;
  white-space: pre-wrap;

  @media (max-width: 820px) {
    padding: 0 24px;
  }
`;
